import useFormValidation from "hooks/useFormValidation";
import { Label } from "layout/typography/Label";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";

const StyledMessage = styled(Message)`
  justify-content: flex-start;
`;

interface IFeatureFlagItem {
  name: string;
  label: string;
  description?: string;
}

const integrationFlags: IFeatureFlagItem[] = [
  {
    name: "features.athenaImport",
    label: "Athena Import",
    description: "Enable Athena scheduling report import",
  },
  {
    name: "features.hstImport",
    label: "EHR Import",
    description: "Enable EHR data import",
  },
  {
    name: "features.implantSuggestions",
    label: "Implant Suggestions",
    description: "Show implant CPT code suggestions",
  },
  {
    name: "features.useFinix",
    label: "Finix Payments",
    description:
      "Use Finix as the payment processor for this account (requires provider onboarding)",
  },
  {
    name: "features.plasticsReportsEnabled",
    label: "Doctor Revenue Reports",
    description:
      "Show the Doctor Revenue tab (embedded revenue-by-doctor reports) on the account page — plastics accounts only",
  },
];

export function Integrations() {
  const { control, trigger, watch } = useFormContext<any>();
  const { handleOnBlurField } = useFormValidation();

  const useFinix = watch("features.useFinix");

  return (
    <div className="flex flex-column gap-4 border-bottom-1 border-gray-200 pb-4">
      <span className="font-medium text-sm mb-2 text-gray-600">
        INTEGRATIONS
      </span>
      {integrationFlags.map((flag) => (
        <div key={flag.name} className="flex gap-3">
          <Controller
            name={flag.name}
            control={control}
            render={({ field: { onChange, value } }) => (
              <InputSwitch
                inputId={flag.name}
                checked={value || false}
                onChange={(e) => onChange(e.value)}
              />
            )}
          />
          <div className="flex flex-column">
            <span className="font-medium text-sm mb-1">{flag.label}</span>
            {flag.description && (
              <span className="text-sm text-gray-500">{flag.description}</span>
            )}
          </div>
        </div>
      ))}
      {/* <div className="flex gap-3">
        <Controller
          name="athenaIntegrationEnabled"
          control={control}
          render={({ field: { onChange, value } }) => (
            <InputSwitch
              inputId="athenaIntegrationEnabled"
              checked={value || false}
              onChange={(e) => onChange(e.value)}
            />
          )}
        />
        <div className="flex flex-column">
          <span className="font-medium text-sm mb-1">Athena Integration</span>
          <span className="text-sm text-gray-500">
            Enable Athena integration
          </span>
        </div>
      </div> */}
      {/* <div className="formgrid grid"> */}
      {/* <div className="field col-6">
          <Label htmlFor="athenaPracticeId">Athena Practice ID</Label>
          <Controller
            name="athenaPracticeId"
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <InputText
                className="w-full"
                id="athenaPracticeId"
                autoComplete="off"
                value={value || ""}
                placeholder="Enter Athena Practice ID"
                aria-labelledby="athenaPracticeId"
                onBlur={() => {
                  handleOnBlurField({
                    onBlur,
                    field: "athenaPracticeId",
                    trigger,
                  });
                }}
                onChange={onChange}
              />
            )}
          />
        </div> */}
      {/* <div className="field col-6">
          <Label htmlFor="athenaDepartmentId">Athena Department ID</Label>
          <Controller
            name="athenaDepartmentId"
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <InputText
                className="w-full"
                id="athenaDepartmentId"
                autoComplete="off"
                value={value || ""}
                placeholder="Enter Athena Department ID"
                aria-labelledby="athenaDepartmentId"
                onBlur={() => {
                  handleOnBlurField({
                    onBlur,
                    field: "athenaDepartmentId",
                    trigger,
                  });
                }}
                onChange={onChange}
              />
            )}
          />
        </div> */}
      {/* </div> */}

      {useFinix && (
        <StyledMessage
          severity="info"
          text="Finix payments are enabled for this account. Ensure all providers are onboarded before patients attempt to pay."
          className="w-full"
        />
      )}
    </div>
  );
}
